import type {MessageDescriptor} from 'react-intl';
import {MAX_PLACES} from './constants';

const getPlaceCountLabel = (
    searchResultCount: number | null,
    formatMessage: (
        messageDescriptor: MessageDescriptor,
        values?: Record<string, any>
    ) => string
) => {
    const messageDescriptor = {
        id: 'placeCountLabel',
        defaultMessage:
            '{resultCount, plural, zero {0 places} one {1 place} few {# places} many {# places} other {# places}}',
        description: 'Label for the amount of places to display',
    };

    return formatMessage(messageDescriptor, {resultCount: searchResultCount});
};

const getPlaceCountPlusLabel = (
    searchResultCount: number | null,
    formatMessage: (
        messageDescriptor: MessageDescriptor,
        values?: Record<string, any>
    ) => string
) => {
    const messageDescriptor = {
        id: 'placeCountPlusLabel',
        defaultMessage:
            '{maxResultCount, plural, few {{maxResultCount}+ places} many {{maxResultCount}+ places} other {{maxResultCount}+ places}}',
        description:
            'Label for the amount of places to display when above max place count',
    };

    return formatMessage(messageDescriptor, {
        maxResultCount: searchResultCount,
    });
};

export const getFormattedResults = (
    searchResultCount: number,
    formatMessage: (
        messageDescriptor: MessageDescriptor,
        values?: Record<string, any>
    ) => string
) => {
    const searchResultCountDisplay =
        searchResultCount >= MAX_PLACES ? MAX_PLACES : searchResultCount;
    const isMaxMoreThanAllowedPlaces = searchResultCount > MAX_PLACES;

    return isMaxMoreThanAllowedPlaces
        ? getPlaceCountPlusLabel(searchResultCountDisplay, formatMessage)
        : getPlaceCountLabel(searchResultCountDisplay, formatMessage);
};
